import { useSelector } from 'react-redux';

import { RootState } from '../redux/rootReducer';
import { LanguageDbHashType } from '../redux/languageDbSlice';

const useLanguageDb = (): LanguageDbHashType => {
  const languageDb = useSelector((state: RootState) => state.languageDb);
  const value = languageDb.languages;

  return value;
}

export default useLanguageDb;
